<script setup lang="ts">
import { EButton, ETooltip, useTheme } from '@erpx/ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

/**
 * The shared icon set is deliberately small and carries no sun/moon glyph, so
 * the two marks are drawn here rather than borrowing an unrelated icon that
 * would read as something else. They are `aria-hidden`; the button's label is
 * what announces the action.
 */
const { resolved, toggle } = useTheme()
const { t } = useI18n()

const label = computed(() =>
  resolved.value === 'dark' ? t('shell.theme.toLight') : t('shell.theme.toDark'),
)
</script>

<template>
  <ETooltip :content="label">
    <EButton variant="ghost" size="sm" icon-only :aria-label="label" @click="toggle">
      <template #icon>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.75"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <template v-if="resolved === 'dark'">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
          </template>
          <path v-else d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
        </svg>
      </template>
    </EButton>
  </ETooltip>
</template>
